import { render } from "./VueRotation.vue?vue&type=template&id=785bdb67&scoped=true"
import script from "./VueRotation.vue?vue&type=script&lang=js"
export * from "./VueRotation.vue?vue&type=script&lang=js"

import "./VueRotation.vue?vue&type=style&index=0&id=785bdb67&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785bdb67"]])

export default __exports__